var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.mapStyles),attrs:{"id":"2GisMap"}})}
var staticRenderFns = []

export { render, staticRenderFns }